<template>
  <div>
    <CCard>
      <CCardBody>
        <div class="family-info-list" v-if="TopInfo">
          <CRow>
            <CCol class="mb-3">
              <CButton class="p-center" @click="onFamilyAddClick()" color="info"
                ><i class="icon cil-user-follow"></i> 家族登録</CButton
              >
            </CCol>
          </CRow>
          <CRow v-for="data in families" :key="data.id" class="family-list">
            <CCol class="p-0">
              <CCard>
                <CCardBody>
                  <CForm class="member-info edit-form">
                    <CRow>
                      <CCol>
                        <CRow>
                          <CCol class="p-0">
                            <p class="family-id">
                              <strong>カードID:</strong
                              >{{ data.relative.cardId }}
                            </p>
                          </CCol>
                        </CRow>
                        <CInput
                          label="氏"
                          horizontal
                          plaintext
                          v-model="data.relative.familyName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="氏（カナ）"
                          horizontal
                          plaintext
                          v-model="data.relative.firstName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="名"
                          horizontal
                          plaintext
                          v-model="data.relative.givenName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="名（カナ）"
                          horizontal
                          plaintext
                          v-model="data.relative.lastName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="性別"
                          horizontal
                          disabled
                          :options="options.genderOptions"
                          v-model="data.relative.gender"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <!-- <CInput
                          label="生年月日"
                          horizontal
                          plaintext
                          v-model="data.relative.birth"
                        /> -->
                        <div class="form-group form-row">
                          <label class="col-form-label col-sm-3"
                            >生年月日</label
                          >
                          <div class="col-sm-9">
                            <span>{{
                              data.relative.birth | formatDate
                            }}</span>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="関係"
                          horizontal
                          disabled
                          :options="options.relationOptions"
                          :value.sync="data.description"
                        />
                        <!-- v-model="data.name" /> -->
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CButton
                          class="p-center my-2"
                          @click="onFamilyEditClick(data.id)"
                          color="info"
                          ><i class="icon cil-pencil"></i> 編集</CButton
                        >
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
                <!-- <CCardFooter>
                <CButton
                  class="p-center"
                  @click="onFamilyEditClick(data.id)"
                  color="info"
                  ><i class="icon cil-pencil"></i> 編集</CButton
                >
              </CCardFooter> -->
              </CCard>
            </CCol>
          </CRow>
        </div>
        <!-- family-info-list end  -->
        <div class="add-family-info" v-if="addFamilyModal">
          <CRow class="family-list">
            <CCol class="p-0">
              <CCard>
                <CCardBody>
                  <CForm class="member-info edit-form">
                    <CRow>
                      <CCol
                        ><strong class="family-title">家族登録</strong></CCol
                      >
                    </CRow>
                    <CRow>
                      <CCol>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyAdd.familyName.$dirty &&
                            !$v.familyAdd.familyName.required
                          "
                        >
                          氏の入力は必須です
                        </div>
                        <div class="required-mark form-group form-row">
                          <label class="col-form-label col-sm-3">氏</label>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              class="form-control"
                              v-model="familyAdd.familyName"
                              v-on:input="familyName_furigana"
                            />
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyAdd.firstName.$dirty &&
                            !$v.familyAdd.firstName.required
                          "
                        >
                          氏（カナ）の入力は必須です
                        </div>
                        <CInput
                          label="氏（カナ）"
                          class="required-mark"
                          horizontal
                          v-model="familyAdd.firstName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyAdd.givenName.$dirty &&
                            !$v.familyAdd.givenName.required
                          "
                        >
                          名の入力は必須です
                        </div>
                        <div class="required-mark form-group form-row">
                          <label class="col-form-label col-sm-3">名</label>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              class="form-control"
                              v-model="familyAdd.givenName"
                              v-on:input="givenName_furigana"
                            />
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyAdd.lastName.$dirty &&
                            !$v.familyAdd.lastName.required
                          "
                        >
                          名（カナ）の入力は必須です
                        </div>
                        <CInput
                          label="名（カナ）"
                          class="required-mark"
                          horizontal
                          v-model="familyAdd.lastName"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="性別"
                          horizontal
                          :options="options.genderOptions"
                          :value.sync="familyAdd.gender"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="生年月日"
                          type="date"
                          horizontal
                          v-model="familyAdd.birth"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="関係"
                          horizontal
                          :options="options.relationOptions"
                          :value.sync="familyAdd.relation"
                        />
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <CRow class="px-2 py-2">
            <CCol>
              <CButton
                @click="
                  addFamilyModal = false;
                  TopInfo = true;
                "
                color="secondary"
                class="float-left"
              >
                <i class="icon cil-arrow-left"></i> 戻る
              </CButton>
              <CButton
                @click="onFamilyAddRunClick()"
                color="success"
                class="float-right"
              >
                <i class="icon cil-save"></i> 登録
              </CButton>
            </CCol>
          </CRow>
        </div>
        <div class="add-family-info" v-if="editFamilyModal">
          <CRow class="family-list">
            <CCol class="p-0">
              <CCard>
                <CCardBody>
                  <CForm class="member-info edit-form">
                    <CRow>
                      <CCol
                        ><strong class="family-title">家族編集</strong></CCol
                      >
                    </CRow>
                    <CRow>
                      <CCol>
                        <div class="required-mark form-group form-row">
                          <label class="col-form-label col-sm-3">氏</label>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              class="form-control"
                              v-model="familyEdit.familyName"
                              v-on:input="familyName_furigana"
                            />
                          </div>
                        </div>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyEdit.familyName.$dirty &&
                            !$v.familyEdit.familyName.required
                          "
                        >
                          氏の入力は必須です
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="氏（カナ）"
                          horizontal
                          v-model="familyEdit.firstName"
                        />
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyEdit.firstName.$dirty &&
                            !$v.familyEdit.firstName.required
                          "
                        >
                          氏（カナ）の入力は必須です
                        </div>
                        <div
                          class="text-danger input-info"
                          v-if="!$v.familyEdit.firstName.isKana"
                        >
                          氏（カナ）はカタカナを入力してください
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <div class="required-mark form-group form-row">
                          <label class="col-form-label col-sm-3">名</label>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              class="form-control"
                              v-model="familyEdit.givenName"
                              v-on:input="givenName_furigana"
                            />
                          </div>
                        </div>
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyEdit.givenName.$dirty &&
                            !$v.familyEdit.givenName.required
                          "
                        >
                          名の入力は必須です
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="名（カナ）"
                          horizontal
                          v-model="familyEdit.lastName"
                        />
                        <div
                          class="text-danger input-info"
                          v-if="
                            $v.familyEdit.lastName.$dirty &&
                            !$v.familyEdit.lastName.required
                          "
                        >
                          名（カナ）の入力は必須です
                        </div>
                        <div
                          class="text-danger input-info"
                          v-if="!$v.familyEdit.lastName.isKana"
                        >
                          名（カナ）はカタカナを入力してください
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="性別"
                          horizontal
                          required
                          :options="options.genderOptions"
                          :value.sync="familyEdit.gender"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CInput
                          label="生年月日"
                          type="date"
                          horizontal
                          required
                          v-model="familyEdit.birth"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CSelect
                          label="関係"
                          horizontal
                          required
                          :options="options.relationOptions"
                          :value.sync="familyEdit.relation"
                        />
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <CRow class="px-2 py-2">
            <CCol>
              <CButton
                @click="
                  editFamilyModal = false;
                  TopInfo = true;
                "
                color="secondary"
                class="float-left"
              >
                <i class="icon cil-arrow-left"></i> 戻る
              </CButton>
              <CButton
                @click="onFamilySaveRunClick()"
                color="success"
                class="float-right"
              >
                <i class="icon cil-save"></i> 保存
              </CButton>
              <!-- <CButton @click="onFamilyDeleteClick()" color="danger">
                <i class="icon cil-trash"></i> 削除
              </CButton> -->
            </CCol>
          </CRow>
        </div>
        <div class="complited-msg" v-if="completedModal">
          <CAlert color="success"> 更新が完了しました。 </CAlert>
          <CButton
            class="p-center"
            onclick="window.location.reload();"
            color="success"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >
        </div>
      </CCardBody>
    </CCard>

    <!-- <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      更新が完了しました。
      <template #header> 更新完了 </template>
      <template #footer>
        <CButton @click="completedModal = false" color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal> -->

    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="deleteConfirmModal"
    >
      削除してよろしいですか？
      <template #header> 削除確認 </template>
      <template #footer>
        <CButton
          @click="deleteConfirmModal = false"
          color="secondary"
          class="float-left"
        >
          <i class="icon cil-x"></i> キャンセル
        </CButton>
        <CButton @click="onFamilyDeleteRunClick()" color="danger">
          <i class="icon cil-trash"></i> 実行
        </CButton>
      </template>
    </CModal>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="deleteCompleteModal"
    >
      削除が完了しました。
      <template #header> 削除完了 </template>
      <template #footer>
        <CButton @click="deleteCompleteModal = false" color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import Options from "./Options";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import historykana from "historykana";
import * as wanakana from "wanakana";

export default {
  name: "FamilyMember",
  components: {},
  data() {
    return {
      TopInfo: true,
      completedModal: false,
      addFamilyModal: false,
      editFamilyModal: false,
      deleteConfirmModal: false,
      deleteCompleteModal: false,
      engFirstName: true,
      engLastName: true,
      tableItems: [],
      copyItems: [],
      families: [],
      familyAdd: {
        familyName: "",
        givenName: "",
        firstName: "",
        lastName: "",
      },
      familyEdit: {
        familyName: "",
        givenName: "",
        firstName: "",
        lastName: "",
      },

      relationId: "",
      fullName: "",

      options: Options.data(),
      history: [],
    };
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    return {
      familyAdd: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(100),
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(100),
        },
        gender: {
          required,
          birth: {
            required,
          },
          relation: {
            required,
          },
        },
      },
      familyEdit: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(100),
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(100),
        },
      },
    };
  },
  // validations: {
  //   familyAdd: {
  //     givenName: {
  //       required,
  //     },
  //     familyName: {
  //       required,
  //     },
  //     lastName: {},
  //     firstName: {},
  //     gender: {
  //       required,
  //     },
  //     birth: {
  //       required,
  //     },
  //     relation: {
  //       required,
  //     },
  //   },
  // },

  methods: {
    /**
     * 家族会員登録の実装
     */
    addFamily() {
      var urlRequest = "/rest/users/" + this.gUserName + "/relative";

      console.log(this.familyAdd);
      axios
        .post(urlRequest, this.familyAdd, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family added:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
          console.log("Family added error: " + err);
          this.errors = err;
        });
    },

    /**
     * 全家族会員の取得
     */
    getFamilies() {
      var urlRequest = "/rest/users/" + this.gUserName + "/relative";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Families get: ");
          console.log(resp.data);
          this.families = [];
          this.families = resp.data;
        })
        .catch((err) => {
          console.log("Families get error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族会員1人分の取得（未使用）
     */
    getFamily() {
      var urlRequest =
        "/rest/users/" + this.gUserName + "/relative/" + this.relationId;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family get:" + JSON.stringify(resp.data));
        })
        .catch((err) => {
          console.log("Families get error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族1人更新リクエスト
     */
    putFamily() {
      // NOTE: 会員更新同様の処理を行う
      var urlRequest = "/rest/users/" + this.familyEdit.name;

      console.log(this.familyEdit);
      axios
        .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family put:" + JSON.stringify(resp.data));
          // NOTE: 会員更新は関係がないため、別途関係更新リクエストが必要
          this.putRelation();
          this.getFamilies();
          this.completedModal = true;
        })
        .catch((err) => {
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 関係更新リクエスト
     */
    putRelation() {
      // NOTE: 会員と家族の関係更新のみの処理を行う
      var urlRequest =
        "/rest/users/" + this.gUserName + "/relative/" + this.relationId;

      const body = {
        name: this.familyEdit.relation,
        description: this.familyEdit.relation,
      };

      console.log(body);
      axios
        .put(urlRequest, body, {
          // .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Relation put:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族1人削除リクエスト
     */
    deleteFamily() {
      var urlRequest =
        "/rest/users/" + this.gUserName + "/relative/" + this.relationId;

      axios
        .delete(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family deleted:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
          console.log("Family delete error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族登録ボタンクリック
     */
    onFamilyAddClick() {
      // 家族登録ダイアログのデータを初期化
      {
        this.familyAdd.givenName = "";
        this.familyAdd.familyName = "";
        this.familyAdd.lastName = "";
        this.familyAdd.firstName = "";
        this.familyAdd.gender = "UNKNOWN";
        this.familyAdd.birth = "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyAdd.password = "";
        this.familyAdd.relation = "OTHER";
      }

      this.addFamilyModal = true;
      this.TopInfo = false;
    },

    /**
     * 家族登録ボタンクリック
     */
    onFamilyAddRunClick() {
      this.addFamily();
      this.addFamilyModal = false;
      this.TopInfo = false;
      this.completedModal = true;
    },

    /**
     * 家族編集ボタンクリック
     */
    onFamilyEditClick(id) {
      this.relationId = id;
      const editData = this.families.filter((a) => a.id == id)[0];

      // 家族編集ダイアログのデータを初期化
      {
        this.familyEdit.givenName = editData.relative.givenName || "";
        this.familyEdit.familyName = editData.relative.familyName || "";
        this.familyEdit.lastName = editData.relative.lastName || "";
        this.familyEdit.firstName = editData.relative.firstName || "";
        this.familyEdit.gender = editData.relative.gender || "UNKNOWN";
        this.familyEdit.birth = editData.relative.birth || "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyEdit.password = "";
        this.familyEdit.relation = editData.description || "OTHER";
        // this.familyEdit.relationName = editData.name || "OTHER";
        this.familyEdit.userName = editData.relative.name || "";
        this.familyEdit.cardId = editData.relative.cardId || "";
        this.familyEdit.id = editData.relative.id || "";
        this.familyEdit.name = editData.relative.name || "";
        this.familyEdit.status = editData.relative.status || "";
      }

      this.TopInfo = false;
      this.editFamilyModal = true;
    },

    /**
     * 家族保存ボタンクリック
     */
    onFamilySaveRunClick() {
      this.putFamily();
      this.TopInfo = false;
      this.editFamilyModal = false;
    },

    /**
     * 家族削除ボタンクリック
     */
    onFamilyDeleteClick() {
      this.deleteConfirmModal = true;
    },

    /**
     * 家族削除実行ボタンクリック
     */
    onFamilyDeleteRunClick() {
      this.deleteFamily();
      this.editFamilyModal = false;
      this.deleteConfirmModal = false;
      this.deleteCompleteModal = true;
    },

    /**
     * 家族カードID編集ボタンクリック
     */
    onFamilyCardIdEditClick(id) {
      this.relationId = id;
      const editData = this.families.filter((a) => a.id == id)[0];

      // 家族カードID編集ダイアログのデータを初期化
      {
        this.familyEdit.givenName = editData.relative.givenName || "";
        this.familyEdit.familyName = editData.relative.familyName || "";
        // this.familyEdit.lastName = editData.relative.lastName || "";
        // this.familyEdit.firstName = editData.relative.firstName || "";
        // this.familyEdit.gender = editData.relative.gender || "UNKNOWN";
        // this.familyEdit.birth = editData.relative.birth || "";
        // this.familyEdit.password = "";
        // this.familyEdit.relation = editData.description || "OTHER";
        // this.familyEdit.userName = editData.relative.name || "";
        this.familyEdit.cardId = editData.relative.cardId || "";
        // this.familyEdit.id = editData.relative.id || "";
        // this.familyEdit.name = editData.relative.name || "";
        // this.familyEdit.status = editData.relative.status || "";
      }

      this.editCardIdModal = true;
    },

    // TODO: 仕様確認
    /**
     * 家族カードID保存ボタンクリック
     */
    onFamilyCardIdSaveRunClick() {
      this.putFamilyCardId();
      this.editCardIdModal = false;
      this.completedModal = true;
    },

    // TODO: 仕様確認
    /**
     * 家族カードID更新リクエスト
     */
    putFamilyCardId() {},

    setFullName(value) {
      this.fullName = value;
    },
    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyAdd.firstName = input.target.value;
        this.familyEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.familyAdd.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyAdd.lastName = input.target.value;
        this.familyEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.familyAdd.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
  },
  beforeMount() {
    this.gUserName = this.$keycloak.userName;
    this.getFamilies();
  },
};
</script>

<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  margin: 0;
  .card-body {
    .card-body {
      padding: 0 !important;
    }
    .alert {
      font-size: 0.85rem;
    }
    .form-row {
      margin: 0 0 1rem;
    }
    .col-sm-3 {
      width: 30%;
    }
    .col-sm-9 {
      width: 70%;
      padding-left: 2%;
    }
    .form-row {
      margin: 0;
    }
    .text-danger {
      padding-left: 32%;
    }
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
.family-list {
  border: 1px solid #cccccc;
  border-radius: 10px;
  margin: 0 1% 5%;
  background: #f2f3f7;
  .card,
  .card-footer,
  .card-header {
    background: none;
  }
  .family-id {
    padding: 1em 0;
    margin: 0;
    font-size: 1.1rem;
    strong {
      padding: 0 5px 0 2px;
      margin-right: 10px;
      color: #ffffff;
      border-radius: 5px;
      padding: 4px 10px;
      font-weight: normal;
      background: #3c4b64;
    }
  }
}

.family-title {
  border-bottom: 3px solid #3c3c3c;
  font-size: 1.4em;
  font-weight: normal;
  margin-bottom: 15px;
  padding: 4px 5px;
  display: inline-block;
}
.btn {
  width: 45%;
}
</style>